import { configureStore } from '@reduxjs/toolkit';
import { statApi } from 'redux/reducers/stat';

const store = configureStore({
  reducer: {
    [statApi.reducerPath]: statApi.reducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat([
    statApi.middleware,
  ]),
});

export default store;
